import classnames from 'classnames';
import React from 'react';

import cs from 'app/components/Sidebar/styles.module.scss';

export interface SidebarHeaderProps {
  title: React.ReactNode;
  /** Metadata line under the title — area, counts, dates. */
  subtitle?: React.ReactNode;
  /** Edit controls, revealed on hover or keyboard focus. */
  hoverActions?: React.ReactNode;
  className?: string;
}

export const SidebarHeader: React.FC<SidebarHeaderProps> = ({
  title,
  subtitle,
  hoverActions,
  className,
}) => (
  <div className={classnames(cs.header, className)}>
    <div className={cs.headerText}>
      <h3 className={cs.headerTitle}>{title}</h3>
      {subtitle && <div className={cs.headerSubtitle}>{subtitle}</div>}
    </div>
    {hoverActions && <div className={cs.hoverActions}>{hoverActions}</div>}
  </div>
);
